import type { EntityBatchSyncStatus } from './entityMutationSync'
import { deriveSyncOutcome, type SyncOutcome } from './syncOutcome'

// Thin per-surface wrapper. Logic lives in `deriveSyncOutcome` so every
// surface stays in lockstep (v2.1 finding #24 consolidation).
export type WaterSyncOutcome = SyncOutcome

export const deriveWaterSyncOutcome = (params: {
  status: EntityBatchSyncStatus
  skippedNotFoundCount: number
}): WaterSyncOutcome => deriveSyncOutcome({ ...params, surfaceKey: 'water' })
